import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_transactions_stats",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-4" }
const _hoisted_9 = { class: "col-md-6 grid-margin stretch-card" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "members",
  style: {"overflow-x":"auto"}
}
const _hoisted_18 = { class: "datatables table table-striped table-bordered" }
const _hoisted_19 = { class: "thead-dark" }
const _hoisted_20 = { class: "d-flex align-items-center mb-2 mt-2" }
const _hoisted_21 = { class: "mb-0 dot-font-size" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "col-md-6 grid-margin stretch-card" }
const _hoisted_24 = { class: "card" }
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_not_found = _resolveComponent("not-found")!
  const _component_doughnut_chart = _resolveComponent("doughnut-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestExpensePayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.regulations.by_day.title')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_transactions_stats', 'view'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.i18n.t('symbole.month')) + " : ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.i18n.t('date.month.' +
                                (_ctx.defaultSearchBy?.month?.toLowerCase() ||
                                    ''))), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.regulations.table')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.regulationsSalesList?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("table", _hoisted_18, [
                              _createElementVNode("thead", _hoisted_19, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('symbole.day')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('symbole.year')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.regulations_stats.total')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regulationsSalesList, (regulation, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    value: "member.id",
                                    key: index
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(regulation?.day), 1),
                                    _createElementVNode("td", null, _toDisplayString(regulation?.year), 1),
                                    _createElementVNode("td", null, _toDisplayString(regulation?.amount_paid) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.i18n.t('tables.regulations_stats.total_amount')), 1),
                                _createElementVNode("h4", null, _toDisplayString(_ctx.totalSales) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_not_found, {
                              text: _ctx.i18n.t('message.data_not_found.title'),
                              icon: "warning"
                            }, null, 8, ["text"])
                          ]))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.i18n.t('views.clients.expense.payment.regulations.chart')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (_ctx.regulationsSalesList?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_doughnut_chart, { chartData: _ctx.chartData }, null, 8, ["chartData"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(_component_not_found, {
                              text: _ctx.i18n.t('message.data_not_found.title'),
                              icon: "warning"
                            }, null, 8, ["text"])
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}